import ApiService from "@/core/services/api.service";

// action types
export const FETCH_CHANNELS = "fetchChannels";
export const FETCH_CHANNEL = "fetchChannel";
export const STORE_CHANNEL = "storeChannel";
export const UPDATE_CHANNEL = "updateChannel";
export const UPDATE_CHANNEL_PHOTO = "updateChannelPhoto";
export const SET_PHOTO_PROGRESS = "setPhotoProgress";
export const UPDATE_CHANNEL_BANNER = "updateChannelBanner";
export const SET_BANNER_PROGRESS = "setBannerProgress";
export const DESTROY_CHANNEL = "destroyChannel";
export const STORE_CHANNEL_PROGRAM = "storeChannelProgram";
export const DESTROY_CHANNEL_PROGRAM = "destroyChannelProgram";

// mutation types
export const SET_CHANNELS = "setChannels";
export const SET_CHANNEL = "setChannel";

const state = {
  channels: [],
  channel: [],
  channelPhotoProgress: 0,
  channelBannerProgress: 0
};

const getters = {
  channels(state) {
    return state.channels;
  },
  channel(state) {
    return state.channel;
  },
  channelPhotoProgress(state) {
    return state.channelPhotoProgress;
  },
  channelBannerProgress(state) {
    return state.channelBannerProgress;
  }
};

const actions = {
  [FETCH_CHANNELS](context) {
    return new Promise((resolve, reject) => {
      ApiService.get("channels")
        .then(({ data }) => {
          context.commit(SET_CHANNELS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_CHANNEL](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get("channels", id)
        .then(({ data }) => {
          context.commit(SET_CHANNEL, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_CHANNEL](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("channels", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_CHANNEL](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update("channels", payload.id, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_CHANNEL_PHOTO]({ commit }, payload) {
    const data = new FormData();
    data.append("photo", payload.file);

    // axios config - progress bar
    const config = {
      onUploadProgress(progressEvent) {
        const progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        commit(SET_PHOTO_PROGRESS, progress);
      }
    };

    return new Promise((resolve, reject) => {
      ApiService.put(`channels/${payload.channel}/photo`, data, config)
        .then(({ data }) => {
          commit(SET_PHOTO_PROGRESS, 0);
          resolve(data);
        })
        .catch(({ response }) => {
          commit(SET_PHOTO_PROGRESS, 0);
          reject(response);
        });
    });
  },
  [UPDATE_CHANNEL_BANNER]({ commit }, payload) {
    const data = new FormData();
    data.append("banner", payload.file);

    // axios config - progress bar
    const config = {
      onUploadProgress(progressEvent) {
        const progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        commit(SET_BANNER_PROGRESS, progress);
      }
    };

    return new Promise((resolve, reject) => {
      ApiService.put(`channels/${payload.channel}/banner`, data, config)
        .then(({ data }) => {
          commit(SET_BANNER_PROGRESS, 0);
          resolve(data);
        })
        .catch(({ response }) => {
          commit(SET_BANNER_PROGRESS, 0);
          reject(response);
        });
    });
  },
  [DESTROY_CHANNEL](context, id) {
    return new Promise(resolve => {
      ApiService.delete(`channels/${id}`).then(({ data }) => {
        context.commit(SET_CHANNELS, {});
        context.commit(SET_CHANNEL, {});
        resolve(data);
      });
    });
  },
  [STORE_CHANNEL_PROGRAM](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(
        `programs/${payload.program}/channels/${payload.channel}`,
        payload
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESTROY_CHANNEL_PROGRAM](context, payload) {
    return new Promise(resolve => {
      ApiService.delete(
        `programs/${payload.program}/channels/${payload.channel}`
      ).then(({ data }) => {
        resolve(data);
      });
    });
  }
};

const mutations = {
  [SET_CHANNELS](state, channels) {
    state.channels = channels;
  },
  [SET_CHANNEL](state, channel) {
    state.channel = channel;
  },
  [SET_PHOTO_PROGRESS](state, value) {
    state.channelPhotoProgress = value;
  },
  [SET_BANNER_PROGRESS](state, value) {
    state.channelBannerProgress = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
